import type { UploadedFileMeta } from '../api/uploads';

export function parseUploadedFileMeta(value?: string): UploadedFileMeta | null {
  if (!value) return null;
  try {
    const parsed = JSON.parse(value) as UploadedFileMeta;
    if (parsed && typeof parsed.fileUrl === 'string') {
      return {
        ...parsed,
        scanStatus: parsed.scanStatus ?? 'clean',
      };
    }
  } catch {
    if (typeof value === 'string' && value.length > 0) {
      return {
        fileUrl: value,
        fileName: 'Uploaded CV',
        uploadedAt: new Date().toISOString(),
        size: 0,
        mimeType: 'application/octet-stream',
        scanStatus: 'clean',
      };
    }
  }
  return null;
}
